import { HHStack } from '@hinge-health/react-component-library';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Navigate, Route, Routes } from 'react-router-dom';
import { SnackbarProvider } from '../billing-tool/context/snackbar.context';
import AccountingBreadcrumbs from './components/accounting-breadcrumbs';
import { routes } from './constants/strings/routes';
import AccountingHomePage from './pages/accounting-home';
import AccountingCsvUpload from './pages/csv-upload';
import SubscriptionEstimates from './pages/subscription-estimates';

export const Accounting = (): JSX.Element => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <SnackbarProvider>
      <HHStack
        display="flex"
        flexDirection="column"
        height="100%"
        minWidth="0"
        sx={{ backgroundColor: '#fff' }}
      >
        <AccountingBreadcrumbs />
        <Routes>
          <Route index element={<AccountingHomePage />} />
          <Route
            path={routes.accounting.subscriptionEstimates}
            element={<SubscriptionEstimates />}
          />
          <Route
            path={routes.accounting.csvUpload}
            element={<AccountingCsvUpload />}
          />
          <Route path="*" element={<Navigate to={routes.accounting.home} />} />
        </Routes>
      </HHStack>
    </SnackbarProvider>
  </LocalizationProvider>
);
